module.exports = __webpack_public_path__ + "static/media/ysjp2@2x.f18f0f06.png";